import { SettingsData } from "../../../../Types/VideoSuite-Types";

export // function take object and return array of object with title and value
const getSettingsData = (settings: SettingsData) => {
  const settingsData = Object.entries(settings).map(([key, value]) => {
    // skip if value is empty or null
    if (value === "") return null;
    return {
      title: key.charAt(0).toUpperCase() + key.slice(1),
      value: value,
    };
  });
  return settingsData;
};

// function take dateTime 2023-10-05T12:00:00Z and return time with AM/PM format
export const formatDateTime = (dateTime: string) => {
  const date = new Date(`${dateTime}Z`);
  const options: Intl.DateTimeFormatOptions = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };
  return date.toLocaleString("en-US", options);
};
